import { createStyles } from "@mantine/emotion";

export default createStyles ( () => ( {
	mainContianer: {
		padding        : "5px 10px",
		display        : "flex",
		justifyContent : "space-between",
		alignItems     : "center"
	},
	commentTopContainer: {
		display        : "flex",
		marginLeft     : "15px",
		borderRadius   : "20px",
		width          : "fit-content",
		paddingRight   : "10px",
		fontSize       : "12px",
		alignItems     : "center",
		paddingTop     : "5px",
		paddingBottom  : "5px",
		justifyContent : "center",
		cursor         : "pointer"
	},
	commentAvatar: {
		height       : "40px",
		width        : "40px",
		objectFit    : "cover",
		borderRadius : "50%"
	},
	commentNameContainer: {
		flex: "1"
	},
	commentName: {
		wordBreak  : "break-all",
		fontWeight : "500",
		fontSize   : "1.3rem",
		marginLeft : "10px"
	},
	svgIcon: {
		cursor : "pointer",
		height : "3rem",
		width  : "3rem"
	}
} ) );